import { render } from "./AccountAddresses.vue?vue&type=template&id=9116205a"
import script from "./AccountAddresses.vue?vue&type=script&lang=js"
export * from "./AccountAddresses.vue?vue&type=script&lang=js"

import "./AccountAddresses.vue?vue&type=style&index=0&id=9116205a&scroped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__